import { Button, Heading,Input,Table, Tbody, Td, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import axios from 'axios';
import React from 'react'
import { useRef } from 'react'
import base_url from "../../utils/getlink";
import { useEffect } from 'react';
import { useState } from 'react';

const AdminCreate = () => {
  const [adminData,setAdminData]=useState([]);
  const nameRef = useRef();
  const emailRef = useRef();
  const passRef = useRef();
  const toast = useToast();
  const handleAdd=()=>{
    const data = {
      name:nameRef.current.value,
      email:emailRef.current.value,
      password:passRef.current.value,
      role:'admin'
    }

    axios({
      method:'post',url:`${base_url}/users/signup`,data:data
    }).then((res)=>{
      console.log(res.data);
      toast({
        status:'success',
        title:'created admin successfully.',
        duration:2000,
        isClosable:true,
        postion:'bottom right'
      })
    }).catch((err)=>{
      console.log(err);
      toast({
        status:'err',
        title:'something went wrong',
        duration:2000,
        isClosable:true,
        postion:'top'
      })
    })
  }

  useEffect(()=>{
    axios({
      method:'get',
      url:`${base_url}/users/getuser?role=admin`
    }).then((res)=>{
      setAdminData(res.data);
    }).catch((err)=>{
      console.log(err);
      console.log("something went wrong.");
    });
  })
  return (
    <div>
      <div>
        <Heading size='lg'>Create New One</Heading>
          <Input type="text" placeholder="Name" ref={nameRef} />
          <Input type="email" placeholder="Email" ref={emailRef} />
          <Input type="password" placeholder='Password' ref={passRef} />
          <Button onClick={handleAdd}>Create New Admin</Button>
      </div>
      <br/>
      <div>
        <Heading size='md'>All Admins</Heading>
        <Table>
          <Thead>
            <Tr>
              <Th>Name</Th><Th>Email</Th>
            </Tr>
          </Thead>
          <Tbody>
            {adminData.length>0&&adminData.map((e)=>(<Tr key={e._id}>
              <Td>{e.name}</Td>
              <Td>{e.email}</Td>
            </Tr>))}
          </Tbody>
        </Table>
      </div>
    </div>
  )
}

export default AdminCreate